module.exports = __webpack_public_path__ + "static/logistics-delivery-8172d8f169c822b01a9e39dab3338385.png";